import React from 'react';
import { TextField, Tooltip } from "@material-ui/core";

export default function VarChar({ field, onChange, errors = {}, variant = "outlined", value, small = false, onBlur,disabled=false }) {
  let iserror = errors[field.name] ? true : false;
  return (
    <Tooltip
      title={field.comment || ''}
      disableHoverListener={field.comment ? false : true}
      placement="top-start"
      disableFocusListener={field.comment ? false : true}
      disableTouchListener={field.comment ? false : true}
    >
      <TextField
        id={field.name}
        error={iserror}
        required={field.required === 'true' ? true : false}
        name={field.name}
        size={small ? "small" : "medium"}
        label={field.label}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        variant={variant}
        // placeholder={field.label}
        helperText={errors[field.name] ? errors[field.name] : null}
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        onBlur={onBlur}
        disabled={disabled}
      />
    </Tooltip>
  );
}
